<script>
    export let size = 24
    export let color = '#00669E'
    export let style = ''
    export let title = null
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 512 512"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <line
        x1="256"
        y1="112"
        x2="256"
        y2="400"
        style={`fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:32px`}
    ></line>
    <line
        x1="400"
        y1="256"
        x2="112"
        y2="256"
        style={`fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:32px`}
    ></line>
</svg>
